export const DEFAULT_TIMEZONE = "Pacific/Auckland";
